import Link from '@/lib/link'
import { ContentPage, Prose, Section } from '@/components/content-page'

export default function AboutPage() {
  return (
    <ContentPage
      eyebrow="// about"
      title="Email should feel personal again"
      description="NewEmail is an independent desktop mail client built around focus, speed, and respect for the person on the other side of the inbox."
    >
      <Prose>
        <Section title="Why another email app?">
          <p>
            Modern inboxes are crowded with promotions, notifications, and features that compete
            for attention instead of helping you finish. NewEmail takes the opposite approach: a
            clear mail workspace, familiar folders, quick search, and a composer that stays out of
            your way.
          </p>
          <p>
            It speaks the protocols your provider already supports. You keep your address, your
            mail history, and your choice of provider. NewEmail is the place you read and write it.
          </p>
        </Section>

        <Section title="The principles">
          <div className="grid gap-4 sm:grid-cols-3">
            {[
              ['Local-first', 'Cached mail keeps the interface quick and useful even when the network is not.'],
              ['Portable', 'Standard IMAP and SMTP mean no provider lock-in and no new email address.'],
              ['Quiet', 'No feed, no engagement loop, and no reason to keep you scrolling after you are done.'],
            ].map(([title, body]) => (
              <div key={title} className="rounded-xl border border-border bg-card p-5">
                <h3 className="font-bold text-foreground">{title}</h3>
                <p className="mt-2 text-sm leading-relaxed">{body}</p>
              </div>
            ))}
          </div>
        </Section>

        <Section title="Who makes it">
          <p>
            NewEmail is designed and developed by Rick Lopez, with feedback from the people who use
            it every day. The source is public on GitHub, and the community forum is the best place
            to compare notes.
          </p>
          <div className="flex flex-wrap gap-3">
            <a
              href="mailto:rick@new-email.net"
              className="inline-flex w-fit items-center gap-2 rounded-lg bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-opacity hover:opacity-90"
            >
              Email the team
            </a>
            <a
              href="https://github.com/ricktek954/newemail"
              target="_blank"
              rel="noreferrer"
              className="inline-flex w-fit items-center gap-2 rounded-lg border border-border bg-card px-5 py-2.5 text-sm font-semibold text-foreground transition-colors hover:border-primary/40"
            >
              View source
            </a>
          </div>
        </Section>

        <Section title="Get involved">
          <p>
            Start with the <Link href="/docs" className="text-primary underline underline-offset-4">setup guide</Link>,
            then join the <Link href="/forum" className="text-primary underline underline-offset-4">community forum</Link>.
            Bug reports and thoughtful feature requests genuinely shape the next release.
          </p>
        </Section>
      </Prose>
    </ContentPage>
  )
}
